<template>
  <div>
    <div class="advanceParent">
      <app-history
        @clicked="showDialog = true"
        class="advancedSearch"
        title="جستجوی پیشرفته"
      />
      <export-excel
        :data="payments"
        :fields="excelHeaders"
        worksheet="My Worksheet"
        name="گزارش کاربران.xls"
        :stringifyLongNum="true"
      >
        <app-history class="advancedSearch" title="خروجی اکسل" />
      </export-excel>
    </div>
    <div>
      <v-data-table
        :items="filteredUsers"
        :headers="paymentsHeaders"
        class="elevation-1 rounded"
        :footer-props="{
          itemsPerPageAllText: 'همه',
          itemsPerPageText: 'تعداد ردیف',
        }"
        :page.sync="pagination.page"
        :pageSize.sync="pagination.pageSize"
        @pagination="updatePage"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
      >
        <template v-slot:[`item.totalOrderAmount`]="{ item }">
          {{ NumberToLocaleString(item.totalOrderAmount) }}
        </template>
        <template v-slot:[`item.totalPaymentAmount`]="{ item }">
          {{ NumberToLocaleString(item.totalPaymentAmount) }}
        </template>
        <template v-slot:[`item.totalJarimeAmount`]="{ item }">
          {{ NumberToLocaleString(item.totalJarimeAmount) }}
        </template>
        <template v-slot:[`item.remainingCredit`]="{ item }">
          {{ NumberToLocaleString(item.remainingCredit) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn class="dialogButton" rounded @click="openReserve(item)"
            >رزرو</v-btn
          >
          <v-btn class="dialogButton" rounded @click="openOrders(item)"
            >سفارشات</v-btn
          >
          <v-btn class="dialogButton" rounded @click="openPayments(item)"
            >حسابداری</v-btn
          >
        </template>
        <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
          از {{ pageStart }} تا {{ pageStop }}
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="showDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4">
          {{ "انتخاب فرد" }}
        </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field v-model="searchInput"></v-text-field>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> </v-col>
        <v-col class="d-flex fardName" cols="12" sm="8">
          {{ currentFard }}
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تاریخ شروع: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="StartDate"
            @click="onClickDate(1)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تاریخ پایان: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="EndDate"
            @click="onClickDate(2)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="GetBranchTranasctions"
          :disabled="apiRunning"
        >
          جستجو
        </v-btn>
        <v-btn
          color="red white--text"
          class="dialogButton"
          rounded
          @click="clearFilter"
          :disabled="apiRunning"
        >
          پاک کردن
        </v-btn>
        <v-btn class="dialogButton" rounded @click="showDialog = false">
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <date-picker
      ref="datepicker1"
      v-model="StartDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput1"
      @change="onChangeDate($event, 1)"
    ></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <date-picker
      ref="datepicker2"
      v-model="EndDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput2"
      @change="onChangeDate($event, 2)"
    ></date-picker>
    <input id="fileInput2" ref="fileInput2" />
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetBranchTranasctions } from "@/api/payments";
import { FindUserByCode } from "@/api/user";
import moment from "moment-jalaali";
import { toArabicCharacter } from "@/utils/constants";
export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showDialog: false,
      payments: [],

      searchInput: "",
      fardId: 0,
      currentFard: "",
      StartDate: "",
      EndDate: "",
    };
  },
  created() {
    if (this.currentBranch) this.GetBranchTranasctions();
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    pagination() {
      return this.$store.getters.pagination;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    paymentsHeaders() {
      let headers = [
        {
          text: "نام فرد",
          value: "fardName",
          width: "15%",
          sortable: false,
        },
        {
          text: "کد ملی",
          value: "nationalCode",
          width: "10%",
          sortable: false,
        },
      ];
      if (this.StartDate == "" && this.EndDate == "") {
        headers = [
          ...headers,
          {
            text: "اعتبار باقی مانده(ریال)",
            value: "remainingCredit",
            width: "10%",
            cellClass: "cellLtr",
          },
        ];
      } else {
        headers = [
          ...headers,
          {
            text: "مبلغ اعتبار در بازه انتخابی(ریال)",
            value: "remainingCredit",
            width: "10%",
            cellClass: "cellLtr",
          },
        ];
      }
      headers = [
        ...headers,
        {
          text: "مبلغ کل پرداختی(ریال)",
          value: "totalPaymentAmount",
          width: "10%",
          cellClass: "cellLtr",
        },
        {
          text: "مبلغ کل سفارشات(ریال)",
          value: "totalOrderAmount",
          width: "10%",
          cellClass: "cellLtr",
        },
        {
          text: "تعداد کل سفارشات",
          value: "totalOrderCount",
          width: "5%",
          cellClass: "cellLtr",
        },
        {
          text: "تعداد سفارشات تحویل گرفته شده",
          value: "totalDeliveredCount",
          width: "5%",
          cellClass: "cellLtr",
        },
        {
          text: "تعداد سفارشات تحویل گرفته نشده",
          value: "totalNoTahvilCount",
          width: "5%",
          cellClass: "cellLtr",
        },
        {
          text: "جمع جرائم(ریال)",
          value: "totalJarimeAmount",
          width: "5%",
          cellClass: "cellLtr",
        },

        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
          width: "25%",
        },
      ];
      return headers;
    },
    excelHeaders() {
      let headers = {};
      headers["نام فرد"] = "fardName";
      headers["کد ملی"] = {
        field: "nationalCode",
        callback: (value) => {
          return `${value}`;
        },
      };
      if (this.StartDate == "" && this.EndDate == "") {
        headers["اعتبار باقی مانده(ریال)"] = {
          field: "remainingCredit",
          callback: (value) => {
            return this.NumberToLocaleString(value);
          },
        };
      }
      headers["مبلغ کل پرداختی(ریال)"] = {
        field: "totalPaymentAmount",
        callback: (value) => {
          return this.NumberToLocaleString(value);
        },
      };
      headers["مبلغ کل سفارشات(ریال)"] = {
        field: "totalOrderAmount",
        callback: (value) => {
          return this.NumberToLocaleString(value);
        },
      };
      headers["تعداد کل سفارشات"] = {
        field: "totalOrderCount",
        callback: (value) => {
          return this.NumberToLocaleString(value);
        },
      };
      headers["تعداد سفارشات تحویل گرفته شده"] = {
        field: "totalDeliveredCount",
        callback: (value) => {
          return this.NumberToLocaleString(value);
        },
      };
      headers["تعداد سفارشات تحویل گرفته نشده"] = {
        field: "totalNoTahvilCount",
        callback: (value) => {
          return this.NumberToLocaleString(value);
        },
      };
      headers["جمع جرائم(ریال)"] = {
        field: "totalJarimeAmount",
        callback: (value) => {
          return this.NumberToLocaleString(value);
        },
      };

      return headers;
    },
    filteredUsers() {
      return this.payments.filter((single) => {
        return (
          /\d{10}/.test(this.searchInput) ||
          single.fardName.includes(toArabicCharacter(this.searchInput)) ||
          single.fardName.includes(this.searchInput)
        );
      });
    },
  },
  watch: {
    searchInput(value) {
      if (/\d{10}/.test(value)) {
        this.FindUser();
      } else {
        this.currentFard = "";
        this.fardId = 0;
      }
    },
  },
  methods: {
    onChangeDate($event, input) {
      if (input == 1) {
        this.StartDate = $event.format("jYYYY/jMM/jDD");
      } else {
        this.EndDate = $event.format("jYYYY/jMM/jDD");
      }
    },
    NumberToLocaleString(value) {
      return Number(value).toLocaleString();
    },
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    clearFilter() {
      this.fardId = 0;
      this.currentFard = "";
      this.searchInput = "";
      this.StartDate = "";
      this.EndDate = "";
      this.GetBranchTranasctions();
    },
    GetBranchTranasctions() {
      this.$store.commit("SET_TABLE_TEXT", true);
      const tempPagination = this.pagination;
      return new Promise((resolve, reject) => {
        GetBranchTranasctions(
          this.currentBranch.id,

          this.fardId,
          this.StartDate,
          this.EndDate
        )
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.payments = response.data.items;
            this.$store.commit("SET_TABLE_TEXT", false);
            this.showDialog = false;
            this.updatePage(tempPagination);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    openOrders(fard) {
      this.$store.commit("SET_SELECTED_FARD", fard);
      this.$router.push({ path: "/branch/allorders" });
    },
    openReserve(fard) {
      this.$store.commit("SET_SELECTED_FARD", fard);
      this.$router.push({ path: "/branch/reserve" });
    },
    openPayments(fard) {
      this.$store.commit("SET_SELECTED_FARD", fard);
      this.$router.push({ path: "/branch/payments" });
    },
    convertDate(date) {
      return moment(date).format("jYYYY/jMM/jDD HH:mm");
    },

    FindUser() {
      return new Promise((resolve, reject) => {
        FindUserByCode(this.searchInput)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            const data = response.data.data;
            this.fardId = data.fardID;
            this.currentFard =
              data.fardID != 0
                ? data.name + " " + data.family
                : "موردی یافت نشد.";

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updatePage(options) {
      // options.page is the new page number
      // options.itemsPerPage is the new number of items per page
      this.$store.commit("SET_PAGINATION", options);
    },
  },
};
</script>
<style>
.text-start.cellLtr {
  direction: ltr;
  text-align: end !important;
}

.textLtr input {
  direction: ltr;
  text-align: right;
}

.filterButton {
  width: 100%;
}
</style>
